/**
 * Список страниц,
 * на которые пользователю
 * нужно обратить внимание
 */
export const importantPageList = ['/methodist', '/UK4T3']
